import { AnimatePresence, motion } from 'motion/react';
import { useEffect } from 'react';
import { useLocation, useOutlet } from 'react-router';
import { getLenis, LenisProvider } from '@/providers/LenisProvider';
import { CursorTracker } from './CursorTracker';
import { Footer } from './Footer';
import { Navbar } from './Navbar';
import { ScrollProgress } from './ScrollProgress';

export function RootLayout() {
  const location = useLocation();
  const outlet = useOutlet();

  // Reset scroll on every route change (Lenis + native fallback).
  useEffect(() => {
    const lenis = getLenis();
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <LenisProvider>
      <div className="grain min-h-screen">
        <ScrollProgress />
        <CursorTracker />
        <Navbar />
        <AnimatePresence mode="wait">
          <motion.main
            key={location.pathname}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35, ease: 'easeOut' }}
          >
            {outlet}
          </motion.main>
        </AnimatePresence>
        <Footer />
      </div>
    </LenisProvider>
  );
}
